module.exports = __webpack_public_path__ + "img/map_Z5.6.A.01.fa72d946.svg";